module.exports = __webpack_public_path__ + "src/assets/textures/env/small_ladder/small_ladder_512_bake.png";